document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('grafana-container');
  if (!container) return;

  const iframe = document.createElement('iframe');
  iframe.src = 'https://grafana.crawl.allegiantdata.com/public-dashboards/f4ccc1a7809f40b19b30ac4a9e04c631?kiosk';
  iframe.style.width = '100%';
  iframe.style.height = 'calc(100vh - 160px)';
  iframe.style.minHeight = '500px';
  iframe.style.display = 'block';
  iframe.style.border = 'none';
  container.append(iframe);
});
